// packages/data/src/index.ts
import defaultRegistry from "./default-registry.mjs";
import * as plugins from "./plugins/index.mjs";
import { combineReducers as combineReducersModule } from "./redux-store/index.mjs";
import { default as default2 } from "./components/with-select/index.mjs";
import { default as default3 } from "./components/with-dispatch/index.mjs";
import { default as default4 } from "./components/with-registry/index.mjs";
import {
  RegistryProvider,
  RegistryConsumer,
  useRegistry
} from "./components/registry-provider/index.mjs";
import {
  default as default5,
  useSuspenseSelect
} from "./components/use-select/index.mjs";
import { useDispatch } from "./components/use-dispatch/index.mjs";
import { AsyncModeProvider } from "./components/async-mode-provider/index.mjs";
import { createRegistry } from "./registry.mjs";
import { createRegistrySelector, createRegistryControl } from "./factory.mjs";
import { createSelector } from "./create-selector.mjs";
import { controls } from "./controls.mjs";
import { default as default6 } from "./redux-store/index.mjs";
import { keyedReducer } from "./redux-store/keyed-reducer.mjs";
import { dispatch } from "./dispatch.mjs";
import { select } from "./select.mjs";
var combineReducers = combineReducersModule;
function resolveSelect(storeNameOrDescriptor) {
  return defaultRegistry.resolveSelect(
    storeNameOrDescriptor
  );
}
var suspendSelect = (storeNameOrDescriptor) => defaultRegistry.suspendSelect(storeNameOrDescriptor);
var subscribe = (listener, storeNameOrDescriptor) => defaultRegistry.subscribe(listener, storeNameOrDescriptor);
var registerGenericStore = defaultRegistry.registerGenericStore;
var registerStore = defaultRegistry.registerStore;
var use = defaultRegistry.use;
var register = (store) => defaultRegistry.register(store);
export {
  AsyncModeProvider,
  RegistryConsumer,
  RegistryProvider,
  combineReducers,
  controls,
  default6 as createReduxStore,
  createRegistry,
  createRegistryControl,
  createRegistrySelector,
  createSelector,
  dispatch,
  keyedReducer,
  plugins,
  register,
  registerGenericStore,
  registerStore,
  resolveSelect,
  select,
  subscribe,
  suspendSelect,
  use,
  useDispatch,
  useRegistry,
  default5 as useSelect,
  useSuspenseSelect,
  default3 as withDispatch,
  default4 as withRegistry,
  default2 as withSelect
};
//# sourceMappingURL=index.mjs.map
